import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectionStrategy, AfterViewInit, inject, computed, effect } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { isPlatformBrowser, AsyncPipe } from '@angular/common';
import { Blog } from '../../../blogs/models';
import { map } from 'rxjs/operators';

import * as fromRoot from '../../../store';
import { DiseaseProfile } from '../../models';
import { StringUtility } from '@teamfoster/sdk/text-utility';
import { getSelectedDiseaseProfile } from '../../store';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@teamfoster/sdk/icon';
import { SafePipe, UrlRewritePipe } from '@teamfoster/sdk/text-utility';
import { SetTags, SetTitle } from '../../../store';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { getCookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';

@Component({
  selector: 'app-disease-profile-info',
  templateUrl: './disease-profile-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, IconComponent, AsyncPipe, UrlRewritePipe, StripEmbedPipe, SafePipe],
})
export class DiseaseProfileInfoComponent {
  #store = inject(Store);
  #dict = new FromDictionaryPipe();

  profile$ = this.#store.selectSignal(getSelectedDiseaseProfile);
  contentType = this.#store.selectSignal(fromRoot.getRouterState);
  contentType$ = computed(() => {
    const state = this.contentType();
    if (!state) {
      return null;
    }
    return state.state.params['contentType'] || state.state.data['contentType'];
  });

  cookiesAccepted$ = this.#store.selectSignal(getCookiePreferences);

  content$ = computed(() => {
    const type = this.contentType$();
    const profile = this.profile$();
    if (!type || !profile) {
      return undefined;
    }
    return profile.informationPages?.find(a => a.slug.toLowerCase() === type.toLowerCase());
  });

  metaEffect = effect(() => {
    const page = this.content$();
    if (!page) {
      return;
    }
    const title = `${page.title} | ${this.#dict.transform('meta-title-suffix')}`;
    const description = StringUtility.Truncate(StringUtility.StripHTML(page.intro || page.text || ''), 157, '...');
    this.#store.dispatch(SetTitle({ title }));
    this.#store.dispatch(SetTags({ properties: { 'description': description, 'og:title': title, 'og:description': description } }));
  });
}
